export * from './dees-appui-tabs.js';
